// extracted by mini-css-extract-plugin
export default {"logo":"RestaurantLogo-module__logo___2VFJ6"};